// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/core/provider.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";

/**
 * Describes the file proto/model/core/provider.proto.
 */
export const file_proto_model_core_provider = /*@__PURE__*/
  fileDesc("Ch9wcm90by9tb2RlbC9jb3JlL3Byb3ZpZGVyLnByb3RvEgZjYXJtZW4ihQEKD1Byb3ZpZGVyTWVzc2FnZRIiCgR0eXBlGAEgASgOMhQuY2FybWVuLlByb3ZpZGVyVHlwZRIOCgZzY2hlbWEYAiABKAkSDwoHY29udGVudBgDIAEoCRItCgl0aW1lc3RhbXAYBCABKAsyGi5nb29nbGUucHJvdG9idWYuVGltZXN0YW1wKkgKDFByb3ZpZGVyVHlwZRIdChlQUk9WSURFUl9UWVBFX1VOU1BFQ0lGSUVEEAASGQoVUFJPVklERVJfVFlQRV9CT09LSU5HEAFCKFomZ2l0aHViLmNvbS95dW5hY2FiYS9jYXJtZW4vcHJvdG8vbW9kZWxiBnByb3RvMw", [file_google_protobuf_timestamp]);

/**
 * Describes the message carmen.ProviderMessage.
 * Use `create(ProviderMessageSchema)` to create a new message.
 */
export const ProviderMessageSchema = /*@__PURE__*/
  messageDesc(file_proto_model_core_provider, 0);

/**
 * Describes the enum carmen.ProviderType.
 */
export const ProviderTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_core_provider, 0);

/**
 * @generated from enum carmen.ProviderType
 */
export const ProviderType = /*@__PURE__*/
  tsEnum(ProviderTypeSchema);

